class ajaxCart extends HTMLElement {
  constructor() {
    super();
    this.drawerScrollTop = 0;
    this.previousBodyOverflow = "";
    this.previousHtmlOverflow = "";
    this.pageScrollLocked = false;
    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    const overlay = this.querySelector("#ajaxcart-overlay");
    if (overlay) {
      overlay.addEventListener("click", this.close.bind(this));
    }
    this.setHeaderCartIconAccessibility();
  }
  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelectorAll('#ajax-cart-icon, #ajax-cart-icon-redesign');
    for (var i = 0; i < cartLink.length; i++) {
      cartLink[i].setAttribute('role', 'button');
      cartLink[i].setAttribute('aria-haspopup', 'dialog');
      cartLink[i].addEventListener('click', (event) => {
        event.preventDefault();
        this.open(event.currentTarget)
      });

      cartLink[i].addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(event.currentTarget);
        }
      });
    }
  }
  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const drawerInner = this.querySelector(".drawer-inner");
    if (drawerInner) {
      drawerInner.style.overflowY = "auto";
      drawerInner.style.overflowX = "hidden";
    }
    this.lockPageScroll();
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });
    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".cart-inner-empty")
          : document.getElementById("ajaxcart");
        const focusElement = this.querySelector(".drawer-inner");
        if (!containerToTrapFocusOn || !focusElement) return;
        triggerClick(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
  }
  close() {
    this.classList.remove("active");
    this.unlockPageScroll();
    triggerClickClose(this.activeElement);
  }
  lockPageScroll() {
    if (this.pageScrollLocked) return;
    this.previousBodyOverflow = document.body.style.overflow;
    this.previousHtmlOverflow = document.documentElement.style.overflow;
    document.documentElement.classList.add("ajax-cart-open");
    document.body.classList.add("ajax-cart-open");
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
    this.pageScrollLocked = true;
  }
  unlockPageScroll() {
    if (!this.pageScrollLocked) return;
    document.documentElement.classList.remove("ajax-cart-open");
    document.body.classList.remove("ajax-cart-open");
    document.documentElement.style.overflow = this.previousHtmlOverflow;
    document.body.style.overflow = this.previousBodyOverflow;
    this.previousHtmlOverflow = "";
    this.previousBodyOverflow = "";
    this.pageScrollLocked = false;
  }
  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }
    cartDrawerNote.parentElement.addEventListener("keyup", escClick);
  }
  renderContents(parsedState) {
    const currentDrawerInner = this.querySelector(".drawer-inner");
    this.drawerScrollTop = currentDrawerInner ? currentDrawerInner.scrollTop : 0;
    if (currentDrawerInner && currentDrawerInner.classList.contains('is-empty')) {
      currentDrawerInner.classList.remove('is-empty');
    }
    this.productId = parsedState.id;

    var parsedCountMarkup = parsedState.sections ? parsedState.sections['ajax-cart-icon'] : null;
    if (parsedCountMarkup) {
      var parsedCount = new DOMParser().parseFromString(parsedCountMarkup, 'text/html');
      var countElement = parsedCount.querySelector(".bigcounter");
      if (countElement) {
        var resultCount = countElement.innerHTML;
        var counterEls = document.querySelectorAll('#ajax-cart-icon-redesign, #ajax-cart-icon');
        counterEls.forEach((element) => {
          var currentCounter = element.querySelector('.bigcounter');
          if (currentCounter) currentCounter.innerHTML = resultCount;
        });
      }
    }

    this.fetchSecToInclude().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if (!sectionElement || !parsedState.sections || !parsedState.sections[section.id]) return;
      const sectionMarkup = this.callSectionInnerHTML(parsedState.sections[section.id], section.selector);
      if (sectionMarkup !== null) sectionElement.innerHTML = sectionMarkup;
    }));

    setTimeout(() => {
      const nextDrawerInner = this.querySelector(".drawer-inner");
      if (nextDrawerInner) {
        nextDrawerInner.style.overflowY = "auto";
        nextDrawerInner.style.overflowX = "hidden";
        nextDrawerInner.scrollTop = this.drawerScrollTop;
      }
      const overlay = this.querySelector('#ajaxcart-overlay');
      if (overlay) overlay.addEventListener('click', this.close.bind(this));
      this.open();
    });
  }
  callSectionInnerHTML(html, selector = ".shopify-section") {
    const section = new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
    return section ? section.innerHTML : null;
  }
  fetchSecToInclude() {
    return [
      {
        id: "ajax-cart",
        selector: "#ajaxcart",
      },
      {
        id: "ajax-cart-icon",
      },
    ];
  }
  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }
  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define("ajax-cart", ajaxCart);
class ajaxCartPro extends CartProduct {
  fetchSecToInclude() {
    return [
      {
        id: "ajaxcart",
        section: "ajax-cart",
        selector: ".drawer-inner",
      },
      {
        id: "ajax-cart-icon",
        section: "ajax-cart-icon",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-pro", ajaxCartPro);
